import React, { useState, useContext } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Currancy } from '../../svg/icons/icon';
import Contextapi from '../../../context-api/createContext';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../Loader';
import { baseUrl } from '../../../utils.jsx/baseUrl';
import { useEffect } from 'react';


function BankAccount({ paymentLeft  }) {
  const {
   
    paymentFlag,
    setPaymentFlag,
    editbanckaccountflag,
    setEditbanckaccountflag,
    bankDetails,
    setBankDetails,
    editbankaccount,
    accountTypeflag,
    seAccountTypetFlag,
  } = useContext(Contextapi);

  const token = sessionStorage.getItem('token');
  const sid = sessionStorage.getItem('sid');

  const [loaderflag, setLoaderflag] = useState(false);
  const [scheduleType, setScheduleType] = useState("");
  const [amount, setAmount] = useState(paymentLeft || bankDetails?.amount ||  "");

  // Sync amount when bankDetails or paymentLeft changes
  useEffect(() => {
    if (bankDetails?.amount !== undefined && bankDetails?.amount !== null) {
      setAmount(bankDetails.amount);
    } else {
      setAmount(paymentLeft || "");
    }
  }, [bankDetails, paymentLeft]);



  const handler = (e) => {
    const value = e.target.value;
    setAmount(value);
    setBankDetails({ ...bankDetails, [e.target.name]: value });
  };

  const handleBlur = () => {
    if (!amount) {
      setAmount(paymentLeft || "");
      setBankDetails({ ...bankDetails, amount: paymentLeft || "" });
    }
  };

  const sendData = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (scheduleType === "") {
      toast.error('Please select a schedule type', { autoClose: 2000 });
      return;
    }

    const url = `${baseUrl.url}/new-payment/add`;

    const payment_type = accountTypeflag ? 'Bank Account' : 'Single Point Wallet';
    const body = {
      bank_accounts: {
        payment_type,
        amount: Number(amount),
        scheduleType,
      },
      schedule_id: sid,
    };

    try {
      setLoaderflag(true);
      const response = await axios.post(url, body, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setPaymentFlag(!paymentFlag);
      setLoaderflag(false);
      toast.success(response.data.message, { autoClose: 1500, pauseOnHover: false });
      setBankDetails({ amount: "", detail: "" });
      setAmount(paymentLeft || "");
      setScheduleType("");
    } catch (error) {
      setLoaderflag(false);
      toast.warn(error?.response?.data?.error || 'Something went wrong', { autoClose: 1500 });
    }
  };

  const update = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      const url = `${baseUrl.url}/new-payment/edit-payment`;
      const payment_type = accountTypeflag ? 'Bank Account' : 'Single Point Wallet';

      const body = {
        schedule_id: sid,
        pay_id: editbankaccount.id,
        payment_type: 'bank_accounts',
        data: {
          payment_type,
          amount: Number(amount),
          id: editbankaccount.id,
          scheduleType,
        },
      };

      setLoaderflag(true);
      const response = await axios.put(url, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("response", response);
      if (response.status === 200) {
        setEditbanckaccountflag(false);

        setBankDetails([]);
        setAmount(paymentLeft || "");
        setScheduleType("");
        setPaymentFlag(!paymentFlag);
        setLoaderflag(false);
        toast.success('Payment Updated', { autoClose: 1000 });
        
        
      // setContext(<BankAccount paymentLeft={paymentLeft} 
      //   // editbanckaccountflag = {false} 
      //   // setEditbanckaccountflag={setEditbanckaccountflag} 
      //   setContext={setContext}
      //   />);
      // setBorderColor1('border-b-2 border-[#258CFB]');
      // setBorderColor2(null);
      // setBorderColor3(null);
     
      }
    } catch (error) {
      console.log(error);
      setLoaderflag(false);
      toast.warn(error?.response?.data?.error || 'Something went wrong', { autoClose: 1000 });
    }
  };

  // Sync scheduleType when editing
  useEffect(() => {
    if (bankDetails && bankDetails.scheduleType) {
      setScheduleType(bankDetails.scheduleType);
    }
  }, [bankDetails]);

  console.log(paymentLeft,'paymentLeft')
  return (
    <>
      {loaderflag && <Loader />}
      <div className="w-full h-full">
        <div className="w-full h-[35px] border-b-[1px] border-b-gray-300 flex gap-[18px] items-center pb-[16px]">
          <div><Currancy /></div>
          <input
            onChange={handler}
            onBlur={handleBlur}
            value={amount}
            type="number"
            placeholder="Requested Amount"
            name="amount"
            className="w-full focus:outline-none placeholder:text-black placeholder:text-opacity-[0.4]"
          />
        </div>

        {/* Account Type */}
        <div className="w-[200px] h-[98px] flex flex-col justify-between mt-[28px]">
          <h4>Type</h4>
          <div className="flex items-center gap-[13px]">
            <input
              type="radio"
              name="payment_type"
              value="Bank Account"
              checked={accountTypeflag}
              onChange={() => seAccountTypetFlag(true)}
            />
            <p className="font-normal text-base text-black">Bank Account</p>
          </div>
          <div className="flex items-center gap-[13px]">
            <input
              type="radio"
              name="payment_type"
              value="Single Point Wallet"
              checked={!accountTypeflag}
              onChange={() => seAccountTypetFlag(false)}
            />
            <p className="font-normal text-base text-black">Single Point Wallet</p>
          </div>
        </div>

        {/* Schedule Type */}
        <div className="font-[400] text-base text-black mt-10">Processing Options</div>
        <div className="flex flex-row mt-4 gap-12 w-full">
          {['Express', 'Priority', 'Standard'].map((type) => (
            <div key={type} className="flex items-center gap-2">
              <input
                type="radio"
                name="scheduleType"
                value={type}
                checked={scheduleType === type}
                onChange={() => setScheduleType(type)}
              />
              <p className="font-normal text-base text-black">
                {type} {type === 'Express' && <span className="text-xs"> (~2 Hrs)</span>}
                {type === 'Priority' && <span className="text-xs"> (Same Day)</span>}
                {type === 'Standard' && <span className="text-xs"> (ACH)</span>}
              </p>
            </div>
          ))}
        </div>

        {/* Submit / Update */}
        <button
          onClick={editbanckaccountflag ? update : sendData}
          type="submit"
          className="mt-[41px] w-full h-[53px] flex justify-center items-center rounded-xl bg-[#258CFB] font-medium text-lg text-white"
        >
          {editbanckaccountflag ? 'Update Payment Instruction' : 'Add Payment Instruction'}
        </button>

        <ToastContainer />
      </div>
    </>
  );
}



export default BankAccount;
